<template>
  <base-section :title="$t('title.promotions')" v-if="promotions.length > 0">
    <template>
      <div class="container">
        <div class="promotions">
          <div class="item" v-for="(promotion, index) in promotions" :key="index" @click="onItemClick($t('route.browse'), promotion.id)">
            <div class="item-padding">
              <img :src="promotion.promotion_image ? promotion.promotion_image.path : ''" />
              <h1>{{ promotion.name }}</h1>
              <h2>{{ promotion.short_description }}</h2>
            </div>
          </div>
        </div>
        <el-row type="flex" justify="center">
          <el-button class="orange-button" @click="onItemClick($t('route.promotions'), undefined)">
            {{ $t('button.viewall') }}
          </el-button>
        </el-row>
      </div>
    </template>
  </base-section>
</template>

<script>
import BaseSection from '@/components/Section'
import Site from '@/api/site'

export default {
  name: 'Section',
  components: {
    BaseSection
  },
  data () {
    return {
      loading: true,
      isCompleted: false,
      isError: false,
      promotions: []
    }
  },
  mounted () {
    const data = { limit: 3 }
    Site.getPromotions(data).then((res) => {
      this.promotions = res.result
      this.loading = false
      this.isCompleted = true
    }).catch((err) => {
      this.loading = false
      this.isCompleted = true
      this.isError = true
      console.log(err)
    })
  },
  methods: {
    onItemClick (name, param) {
      if (param) {
        this.$router.push({ path: `/promotions/${param}` })
      } else {
        this.$router.push({ name })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.promotions {
  width: 100%;
  display: flex;
  align-items: left;
  flex-direction: row;
  flex-wrap: wrap;
  flex-flow: row wrap;
  align-content: flex-end;
  justify-content: center;
  // column-count: 1;
  @media (min-width: 768px) {
    // column-count: 3;
  }
  .item {
    width: 100%;
    text-align: center;

    @media (min-width: 768px) {
      width: 33.33%;
    }

    .item-padding {
      cursor: pointer;
      padding-bottom: 10px;
      @media (min-width: 768px) {
        padding: 10px;
      }
    }
    h1 {
      font-family: 'AlteHaasGroteskBold';
      font-size: 18px;
    }
    h2 {
      font-size: 16px;
      font-weight: normal;
    }
    img {
      width: 100%;
      max-width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/PromotionsSection.vue